import React from 'react';
import PropTypes from 'prop-types';
import Col from '@loggi/ui/components/col';
import Text, {
  TEXT_TYPE_TITLE,
  TEXT_TYPE_REGULAR
} from '@loggi/ui/components/text';
import Button from '@loggi/ui/components/button';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import Image from '@loggi/ui/components/image';
import colors from '@loggi/ui/components/utils/colors';
import contestSent from 'images/contest-sent.png';
import {
  CONTEST_TITLE,
  CONTEST_MESSAGE,
  BUTTON_CONTEST_SENT
} from './end-contest.constants';

import styles from '../confirm-delivery.styles.scss';

export default function EndContestMain(props) {
  const { onClick } = props;
  return (
    <Col className={styles.contestCol}>
      <Col className={styles.contestImage}>
        <Image src={contestSent} noBackgroundColor />
      </Col>
      <Col
        gutter={{
          top: 'double',
          bottom: 'normal'
        }}
      >
        <Text color={colors.type.DARKEST} type={TEXT_TYPE_TITLE}>
          {CONTEST_TITLE}
        </Text>
      </Col>
      <Text color={colors.type.DARK} type={TEXT_TYPE_REGULAR}>
        {CONTEST_MESSAGE}
      </Text>
      <Col
        gutter={{
          top: 'triple'
        }}
      >
        <Button
          shape={ROUNDED_SHAPE}
          style="outline"
          value={BUTTON_CONTEST_SENT}
          onClick={onClick}
        />
      </Col>
    </Col>
  );
}

EndContestMain.propTypes = {
  onClick: PropTypes.func.isRequired
};

EndContestMain.displayName = 'EndContestMain';
